import * as THREE from "three";
import Orchestrator from "../Orchestrator.js";

export default class Environment {
    constructor() {
        this.orc = new Orchestrator();
        this.scene = this.orc.scene;
        this.resources = this.orc.resources;
        this.debug = this.orc.debug;

        this.params = {
            backgroundColor: "#211d20",
        };

        // Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder("environment");
        }

        this.setEnvironmentMap();
    }

    setEnvironmentMap() {
        this.scene.background = new THREE.Color(this.params.backgroundColor);

        // Debug
        if (this.debug.active) {
            this.debugFolder
                .addColor(this.params, "backgroundColor")
                .name("background")
                .onChange((value) => {
                    this.scene.background.set(value);
                });
        }
    }
}
